<template>
  <div >
    <CRow>
      <CCol md="12">
        <CForm>
          <CCard>
            <CCardHeader class="p-1">
              <CRow>
                <CCol col="5" style="text-align: start ;padding:10px 20px 0 20px ">

                  <strong>{{ get_document_type_label }}</strong>
                </CCol>
                <CCol col="2" style="text-align: start ;padding:10px 20px 0 20px ">

                  <CInput
                      :placeholder="$t('tables.barcode')"
                      v-model="barcode_model"
                      id="barcode_model"
                      type="text"
                      autocomplete="off"
                      class="bg-secondary-input"
                      @keypress.enter="search_barcode"
                  />

                </CCol>
                <CCol col="5" style="text-align: end">
                  <!--                                    <CButton v-if="status_form==0 " @click="insert_data_factor()" size="sm"-->
                  <!--                                             color="secondary">-->
                  <!--                                        {{ $t('preview') }}-->
                  <!--                                    </CButton>-->


                  <!--                                    <CButton v-if="status_form!=0" @click="insert_data_factor()" size="sm"-->
                  <!--                                             color="secondary">-->
                  <!--                                        <CIcon size="sm" name="cil-check-circle"/>-->
                  <!--                                        {{ $t('buttons.editDocument') }}-->
                  <!--                                    </CButton>-->
                  <CButton v-if="status_form==0 && !is_year_closed()" class="mr-1 ml-1" @click="insert_data_factor()"
                           size="sm"
                           color="secondary">
                    {{ $t('preview') }} F2
                  </CButton>

                  <CButton v-if="status_form==0  && is_year_closed()" class="mr-1 ml-1"
                           @click="year_closed_dialog()" type="submit"
                           size="sm" color="danger">
                    {{ $t('preview') }}
                  </CButton>

                  <CButton v-if="status_form!=0 && !is_year_closed()" @click="insert_data_factor()" size="sm"
                           color="secondary">
                    {{ $t('buttons.editDocument') }} F2
                  </CButton>
                  <CButton v-if="status_form!=0  && is_year_closed()" class="mr-1 ml-1"
                           @click="year_closed_dialog()" type="submit"
                           size="sm" color="danger">
                    {{ $t('buttons.editDocument') }}
                  </CButton>
                  <CButton
                      class="mr-1"
                      size="sm"
                      color="secondary"
                      @click="emptyList"
                  >{{ $t("buttons.cancel") }}
                  </CButton>

                  <a href="/dashboard/sale-orders/sale-invoice" target="_blank">
                    <CButton
                        class="mr-1 ml-1"
                        size="sm"
                        color="dark"
                    >
                      <CIcon size="sm" name="cil-plus"></CIcon>
                    </CButton>
                  </a>
                </CCol>
              </CRow>
            </CCardHeader>
            <CCardBody>
              <CRow>
                <CCol col="5">
                  <CRow form class="form-group">
                    <CCol tag="label" sm="3" class="col-form-label">
                      {{ $t('customer') }}
                    </CCol>
                    <CCol>
                      <treeselect
                          v-model="document_person"
                          :cacheOptions="false"
                          :async="async_person_search"
                          @select="select_person"
                          :options="async_person_options"
                          :load-options="load_persons"
                          :placeholder="$t('search')"
                          :normalizer="normalizer_persons"
                      />
                      <div style="display: flex;justify-content: space-between;">
                        <label>
                          {{$t('tables.balance')}}:
                          {{get_currency(document_person_remain_amount)}}
                        </label>
                        <label v-if="document_person_credit!=null">
                          {{$t('credit')}}:
                          {{get_currency(document_person_credit)}}
                        </label>
                      </div>

                    </CCol>
                    <CCol col="1" v-if="get_access('super_market_config')">

                      <CButton
                          v-if="document_person==null"
                          @click="new_customer_modal=true"
                          color="dark" size="sm">

                        <CIcon name="cil-plus"
                               size="sm"/>
                      </CButton>
                    </CCol>
                    <CCol col="1" class="m-0">
                      <CButton
                          v-if="document_person!=null"

                          :href="'/dashboard/sale-orders/edit-customer/'+document_person"
                          target="_blank" color="dark" size="sm">
                        <CIcon size="sm" name="cil-user"/>
                      </CButton>
                    </CCol>
                  </CRow>
                </CCol>

                <CCol col="3" v-if="!get_access('hyper_sale')">
                  <CSelect
                      :options="places_items"
                      :label="$t('inventory')"
                      :horizontal="{label: 'col-sm-4', input: 'col-sm-8'}"

                      :value.sync="selected_place"
                  />


                </CCol>
                <CCol col="4" v-if="!get_access('hyper_sale')">
                  <div>
                    <CRow form class="form-group">
                      <CCol tag="label" sm="4" class="col-form-label">
                        {{ $t('components.date') }}
                      </CCol>
                      <CCol sm="8">
                        <date-picker
                            v-model="date"
                            :min="fyear_min_date"
                            :max="fyear_max_date"
                        ></date-picker>
                      </CCol>
                    </CRow>
                  </div>
                </CCol>

              </CRow>

              <CRow >
                <CCol col="4" v-if="selectedType==3">
                  <CRow form class="form-group">
                    <CCol col="4" tag="label" class="col-form-label">
                      {{ $t('payTypeCash') }}
                    </CCol>
                    <CCol col="3">
                      <CSelect
                          :options="pay_type_items"
                          :value.sync="selected_pay_type"
                      />
                    </CCol>
                    <CCol col="5">
                      <CSelect v-if="selected_pay_type==34"
                               :options="cashiers"
                               :value.sync="selected_cashiers"
                      />
                      <CInputCurrency v-if="selected_pay_type==35"
                                      v-model="off_over_nesie"
                      />

                    </CCol>

                  </CRow>

                </CCol>
                <CCol col="2" v-if="get_access('super_market_config')">
                  <CInputCurrency v-if="selected_pay_type==34 && get_access('super_market_config')"
                                  v-model="cashier_payment"
                                  placeholder="مبلغ نقد"
                  />
                </CCol>
                <CCol col="3" v-if="get_access('super_market_config')">
                  <CRow>
                    <CCol col="6" class="pr-0 pl-0">
                      <CSelect v-if="selected_pay_type==34"
                               :options="cashiers.filter(x=>x.isCashier==false)"
                               :value.sync="selected_cashiers_pos"
                      />

                    </CCol>
                    <CCol col="6" style="display: flex" class="pr-0 pl-0">
                      <CInputCurrency v-if="selected_pay_type==34"
                                      v-model="pos_pay"
                                      placeholder="مبلغ کارتخوان"
                      />
                      <CButton @click="send_price_to_pos()"
                               v-if="selected_pay_type==34">
                        <CIcon name="cil-check"/>
                      </CButton>
                    </CCol>
                  </CRow>

                </CCol>

                <CCol col="3">
                  <CSelect

                      :options="delivery_type_items"
                      :label="$t('PriceType')"
                      :horizontal="{label: 'col-sm-4', input: 'col-sm-8'}"

                      :value.sync="delivery_type"
                  />
                </CCol>
                <CCol col="5" v-if="selectedType==3 && !get_access('super_market_config')">
                  <CInput
                      :label="$t('components.documentSummary')"
                      :horizontal="{label: 'col-sm-3', input: 'col-sm-9'}"


                      v-model="document_summary"

                      rows="1"
                  />
                </CCol>
                <CCol col="8" v-if="!get_access('super_market_config') && selectedType!=3">
                  <CTextarea
                      :label="$t('components.documentSummary')"
                      :horizontal="{label: 'col-sm-2', input: 'col-sm-10'}"

                      v-model="document_summary"

                      rows="1"
                  />
                </CCol>

              </CRow>

              <div style="min-height: 250px" class="overflow-auto">
                <CDataTableFixed
                    :items="product_items"
                    :fields="product_fields"
                    @row-clicked="table_row_clicked"
                    :items-per-page="200"
                    hover
                    sorter
                    :sticky_zero="true"

                    :height="get_access('hyper_sale')?'50vh':'40vh'"
                    pagination
                >
                  <template #row="{item,index}">

                    <td  :class="index==last_row_updated?'bg-success':''">
                      <p v-if="index!=0">{{ item.row_id }}</p>

                    </td>

                  </template>
                  <template #name="{item,index}">

                    <td v-if="index==0">
                      <CRow>
                        <CCol col="10" class="m-0 p-0">
                          <AutocompleteSearchProduct
                              v-model="selected_product"
                              @select="select_product"
                              v-if="status_product_form==-1"
                              id="product_seeker"
                              ref="product_searcher"
                          />
<!--                          <treeselect-->
<!--                              :cacheOptions="false"-->
<!--                              v-model="selected_product"-->
<!--                              v-if="status_product_form==-1"-->
<!--                              ref="product_searcher"-->
<!--                              id="product_seeker"-->
<!--                              :async="true"-->
<!--                              :appendToBody="true"-->
<!--                              @select="select_product"-->
<!--                              :load-options="load_products"-->
<!--                              :placeholder="$t('searchItem')"-->
<!--                              :normalizer="normalizer_products"-->
<!--                          />-->
                          <label v-else>{{ product_name }}</label>

                        </CCol>
                        <CCol col="2" class="m-0 p-0">
                          <CButton style="height: 100%;" v-if="selected_product!=null"
                                   size="sm" outline color="dark"
                                   @click="open_selected_product()">
                            <CIcon size="sm" name="cil-cart"/>
                          </CButton>

                        </CCol>
                      </CRow>
                    </td>

                    <td v-else :class="index==last_row_updated?'bg-success':''">
                      <p>{{ item.name }}</p>

                    </td>

                  </template>

                  <template #unit="{item}">

                    <td  :class="index==last_row_updated?'bg-success':''">
                      <p>{{ item.unit_value_name }}</p>

                    </td>

                  </template>

                  <template #count="{item,index}">

                    <td v-if="index==0">
                      <CInputCurrency
                          :whitout_decimal="true"
                          :placeholder="$t('components.productQty')"
                          v-on:keydown.enter="another_focus('product_price_input')"
                          id="product_qty_input"

                          v-model="product_count"
                      />
                    </td>

                    <td v-else  :class="index==last_row_updated?'bg-success':''">
                      <p style="float: right">{{ get_currency_no_fix(item.count) }}</p>

                    </td>

                  </template>
                  <template #price="{item,index}">

                    <td v-if="index == 0">
                      <CInputCurrency
                          v-on:keyup.enter="another_focus('input_off')"
                          :placeholder="$t('components.unitPrice')"
                          id="product_price_input"

                          v-model="product_price"
                      >

                      </CInputCurrency>
                      <label v-if="get_access('purchase_price_in_factor')">
                        {{ $t('buyPrice') }}
                        {{ get_currency(purchase_price) }}
                      </label>
                    </td>
                    <td v-else  :class="index==last_row_updated?'bg-success':''">
                      <p style="float: right">
                        <!--                                                {{ get_currency(item.price*item.unit_value) }}</p>-->
                        {{ get_currency(item.price) }}</p>

                    </td>

                  </template>
                  <template #totalPrice="{item ,index}">

                    <td  :class="index==last_row_updated?'bg-success':''">
                      <p style="float: right" v-if="index !=0">
                        {{
                          get_currency(calculate_total_price(item))
                        }} </p>
                      <p class="text-center pt-1" v-if="index ==0 && selected_product!=null">
                        {{ $t('SaleableQty') }}: {{
                          get_currency((product_existance / product_unit_value),2)
                        }}</p>

                    </td>

                  </template>
                  <template #offPrice="{item,index}">
                    <td  :class="index==last_row_updated?'bg-success':''">
                      <CInputCurrency
                          :whitout_decimal="true"
                          append="%"
                          v-on:keyup.enter="another_focus('input_tax')"
                          id="input_off"
                          v-if="index ==0"
                          v-model="product_off"
                      />
                      <p style="float: right" v-if="index !=0">
                        {{
                          get_currency(calculate_off_price(item))
                        }}
                      </p>
                    </td>
                  </template>
                  <template #taxPrice="{item,index}">
                    <td  :class="index==last_row_updated?'bg-success':''">
                      <CRow v-if="index ==0">
                        <CCol col="10">
                          <CInputCurrency
                              id="input_tax"

                              v-on:keydown.enter="add_product_to_document_new()"

                              v-model="product_tax"
                          >
                            <template #append-content>
                              <span>%</span>
                            </template>

                          </CInputCurrency>
                        </CCol>
                        <CCol col="2" class="p-0 m-0">
                          <CButton style="height: 80%" size="sm" color="dark">
                            <CIcon size="sm" name="cil-plus"
                                   @click.native="add_product_to_document_new"></CIcon>
                          </CButton>
                        </CCol>
                      </CRow>


                      <p style="float: right" v-if="index !=0">
                        {{
                          get_currency(calculate_tax_price(item))
                        }} </p>
                    </td>

                  </template>
                  <template #totalPayPrice="{item,index}">
                    <td  :class="index==last_row_updated?'bg-success':''">
                      <p style="float: right" v-if="index !=0">
                        {{
                          get_currency(calculate_total_pay_price(item))
                        }} </p>
                    </td>

                  </template>
                  <template #weight="{item,index}">

                    <td  :class="index==last_row_updated?'bg-success':''">
                      <p v-if="index !=0">
                        {{
                          (item.weight * item.count * item.unit_value)
                        }}
                      </p>

                    </td>

                  </template>
                  <template #summary="{item}">

                    <td  :class="index==last_row_updated?'bg-success':''">
                      <p>{{ item.summary }}</p>

                    </td>

                  </template>


                  <template #operation="{item,index}">
                    <td>

                      <CIcon v-if="index!=0" class="text-primary mr-1"
                             @click.native="edit_item(item.product_id)"
                             name="cil-pencil"/>

                      <CIcon v-if="index!=0" class="text-danger mr-1"
                             @click.native="delete_item_dialog(item)"
                             name="cil-trash"/>
                      <CButton v-if="status_product_form!=-1 && index==0" title="Cancel" outline
                               color="dark">
                        <CIcon class="text-white" size="sm" name="cil-x"
                               @click.native="cancel_edit_product()"></CIcon>
                      </CButton>

                    </td>
                  </template>


                </CDataTableFixed>

              </div>
              <CRow v-if="!get_access('hyper_sale')">
                <CCol>
                  <CInputCurrency :label="$t('DeliveryCost')"
                                  v-model="delivery_cost_amount"
                                  :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
                  />
                </CCol>
                <CCol>
                  <CSelect :label="$t('anotherCosts')"
                           :options="cost_items"
                           :value.sync="selected_sec_cost"
                           :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
                  >
                    <template #append-content>
                      <CIcon size="sm" v-on:click.native="go_to_add_modal('delivery_costs')"
                             name="cil-plus"/>
                    </template>
                  </CSelect>
                </CCol>
                <CCol>
                  <CInputCurrency :label="$t('tables.amount')"
                                  v-model="sec_cost_amount"
                                  :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
                  />
                </CCol>
                <CCol>
                  <CSelect :label="$t('offType')"
                           :value.sync="total_factor_off_type"
                           :options="[{label:$t('select'),value:0},{label:$t('priceOff'),value:1},{label:$t('percentOff'),value:2}]"
                           :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
                  />
                </CCol>
                <CCol>
                  <CInputCurrency :label="$t('components.off')"
                                  v-model="total_factor_off"

                                  :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
                  />
                </CCol>

              </CRow>
              <CRow v-if="!get_access('hyper_sale')">
                <CCol col="5">
                  <CRow form class="form-group">
                    <CCol tag="label" sm="3" class="col-form-label">
                      {{ $t('visitor') }}
                    </CCol>
                    <CCol>
                      <treeselect
                          v-model="document_visitor"
                          :cacheOptions="false"
                          :async="async_visitor_search"
                          @select="select_person"
                          :options="async_visitor_options"
                          :load-options="load_visitors"
                          :placeholder="$t('search')"
                          :normalizer="normalizer_persons"
                      />
                    </CCol>
                    <CCol col="1" v-if="get_access('super_market_config')">

                      <CButton
                          v-if="document_person==null"
                          @click="new_customer_modal=true"
                          color="dark" size="sm">

                        <CIcon name="cil-plus"
                               size="sm"/>
                      </CButton>
                    </CCol>
                    <CCol col="1" class="m-0">
                      <CButton
                          v-if="document_person!=null"

                          :href="'/dashboard/sale-orders/edit-customer/'+document_person"
                          target="_blank" color="dark" size="sm">
                        <CIcon size="sm" name="cil-user"/>
                      </CButton>
                    </CCol>
                  </CRow>
                </CCol>

              </CRow>
              <CRow>

                <CCol col="12" class="mb-3">
                  <CDataTable
                      v-if="product_items.length>1"

                      :items="document_result_price"
                      :fields="fields_total_price"
                      striped
                      border
                      :items-per-page="200"
                      hover
                      pagination
                  >
                    <template #resultTitle="{item}">

                      <td>
                        <strong>{{ item.resultTitle }}</strong>

                      </td>


                    </template>
                    <template #resultPrice="{item}">

                      <td>
                        <strong>{{
                            currency_with_symbol(item.resultPrice)
                          }}</strong>

                      </td>

                    </template>
                    <template #offPrice="{item}">
                      <td>
                        <strong style="float: right">{{
                            currency_with_symbol(item.offPrice)
                          }}</strong>
                      </td>
                    </template>
                    <template #factor_off="{item}">
                      <td>
                        <strong style="float: right">{{
                            currency_with_symbol(item.factor_off)
                          }}</strong>
                      </td>
                    </template>
                    <template #totalPrice="{item}">
                      <td>
                        <strong style="float: right">{{
                            item.totalPrice
                          }}</strong>
                      </td>
                    </template>
                    <template #payPrice="{item}">
                      <td>
                        <strong style="float: right">{{
                            item.payPrice
                          }}</strong>
                      </td>
                    </template>
                    <template #taxPrice="{item}">
                      <td>
                        <strong style="float: right">{{
                            currency_with_symbol(item.taxPrice)
                          }}</strong>
                      </td>
                    </template>
                    <template #total_weight="{item}">
                      <td>
                        <strong style="float: right">{{
                            get_weight(item.total_weight / 1000)
                          }} {{ $t('kg') }}</strong>
                      </td>
                    </template>


                  </CDataTable>

                </CCol>
              </CRow>

            </CCardBody>

          </CCard>
        </CForm>

      </CCol>
    </CRow>
    <CModal
        title="افزودن مشتری"
        size="sm"
        :closeOnBackdrop=true
        :show.sync="new_customer_modal"
    >
      <CRow>
        <CCol>
          <CInput v-model="new_customer_mobile"
                  :label="$t('mobile')"/>
        </CCol>
      </CRow>
      <CRow>
        <CCol>
          <CInput v-model="new_customer_name"
                  :label="$t('name')"/>
        </CCol>
      </CRow>

      <template #footer>
        <CButton @click="new_customer_modal=false" color="danger">{{ $t('buttons.cancel') }}</CButton>
        <CButton @click="add_new_customer()" color="success">{{ $t('buttons.ok') }}</CButton>
      </template>
    </CModal>

    <vue-context ref="menu">
      <li>
        <a href="#" @click.prevent="edit_item(product_index_clicked)">{{ $t('components.edit') }}</a>
      </li>

      <li>
        <a href="#" @click.prevent="delete_item_dialog(product_items[product_index_clicked])">{{
            $t('buttons.delete')
          }}</a>
      </li>
    </vue-context>
    <div style="display: flex;-ms-flex-wrap: wrap;flex-wrap: wrap;margin-bottom: 36px"
         v-if="get_access('super_market_config')">
      <div @click="add_w_barcode_to_factor(pro)" style="width: 10%;" v-for="(pro,index) in products_w_barcode"
           :key="'wb-'+index">
        <div style="margin:1px;height:35px;border: 1px solid grey;border-radius: 3px">{{ pro.productName }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
// import Vue from "vue";
import Vue from 'vue'
import 'vue-context/src/sass/vue-context.scss';

import VueContext from 'vue-context';
import moment from 'moment-jalaali'

import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
import AutocompleteSearchProduct from "../includes/AutocompleteSearchProduct.vue";
var simulateAsync = null
const simulateAsyncOperation = fn => {
  if (simulateAsync != null) {
    clearTimeout(simulateAsync)
  }
  simulateAsync = setTimeout(fn, 1000)
}



export default {
  name: 'Login',
  components: {
    Treeselect,
    VueContext,
    AutocompleteSearchProduct,
  }, props: {
    selectedType: Number
  },

  data() {
    return {
      last_row_updated:-1,
      key_handler:null,
      document_person_credit:'',
      cashier_payment: '',
      pos_pay: '',
      new_customer_name: '',
      new_customer_mobile: '',
      products_w_barcode: [],
      new_customer_modal: false,
      fyear_min_date: localStorage.getItem('fyear_min_date'),
      fyear_max_date: localStorage.getItem('fyear_max_date'),
      async_person_search: true,
      async_person_options: [],
      off_over_nesie: '0',
      total_factor_off_type: 2,
      total_factor_off: '',
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
      product_index_clicked: 0,
      customer_doc_name: '',
      VUE_APP_Currency: localStorage.getItem('currency'),
      VUE_APP_Weight: localStorage.getItem('weight'),

      document_result_price: [],
      date: '',
      delivery_type: 21,
      delivery_type_items: [],
      product_items: [{id: "0"}],
      product_fields: [
        {key: 'row', label: "No.", _style: 'width:3%;text-align:center'},
        {key: 'name', label: this.$t('item'), _style: 'width:23%;text-align:center'},
        // {key: 'unit', label: this.$t('tables.unit'), _style: 'width:10%;text-align:center'},
        {key: 'count', label: this.$t('tables.qty'), _style: 'width:3%;text-align:center'},
        {key: 'price', label: this.$t('components.unitPrice'), _style: 'width:7%;text-align:center'},
        {key: 'totalPrice', label: this.$t('tables.amount'), _style: 'width:10%;text-align:center'},
        {key: 'offPrice', label: this.$t('tables.off'), _style: 'width:7%;text-align:center'},
        {key: 'taxPrice', label: this.$t('tables.tax'), _style: 'width:10%;text-align:center'},
        {key: 'totalPayPrice', label: this.$t('tables.totalAmount'), _style: 'width:10%;text-align:center'},
        // {key: 'summary', _style: 'width:10%;'},
        {key: 'operation', label: '', _style: 'width:5%;text-align:center'},
      ],
      // fields_total_price: [
      //   {key: 'resultTitle', label: this.$t('tables.name'), _style: 'padding:5px;display:none'},
      //   {key: 'resultPrice', label: this.$t('tables.price'), _style: 'padding:5px;display:none'},
      // ],
      fields_total_price: [
        {key: 'totalPrice', label: this.$t('factorAmount'), _style: 'padding:5px;'},
        {key: 'offPrice', label: this.$t('productDiscount'), _style: 'padding:5px;'},
        {key: 'factor_off', label: this.$t('invoiceDiscount'), _style: 'padding:5px;'},

        {key: 'taxPrice', label: this.$t('vat'), _style: 'padding:5px;'},

        // {key: 'afterOffPrice', label: this.$t('priceAfterOff'), _style: 'padding:5px;'},
        {key: 'payPrice', label: this.$t('payPrice'), _style: 'padding:5px;'},
        // {key: 'beforePrice', label: this.$t('balanceBefore'), _style: 'padding:5px;'},
        // {key: 'finalPrice', label: this.$t('finalPrice'), _style: 'padding:5px;'},
        {key: 'total_weight', label: this.$t('totalWeight'), _style: 'padding:5px;'},
      ],

      cost_items: [],
      selected_first_cost: 0,
      selected_sec_cost: 0,
      delivery_cost_amount: '',
      sec_cost_amount: '',

      selectTypes: [
        {
          value: 1,
          label: this.$t('components.buyDocument')
        },
        {
          value: 3,
          label: this.$t('components.sellDocument')
        },
        {
          value: 5,
          label: this.$t('components.firstDocument')
        },

      ],
      selectedTypeQty: -1,
      selectedTypeLabel: this.$t('components.customer'),

      document_person: null,
      document_person_name: "",
      document_person_method_name: "",
      document_person_remain_amount: "0",
      document_summary: '',

      barcode_model: '',
      purchase_price: '0',
      product_name: '',
      product_non_off: false,
      product_existance: '',
      product_count: '',
      product_unit: '',
      product_unit_name: '',
      product_unit_value: '',
      product_weight: '',
      product_summary: '',
      product_price: '',
      product_off: '',
      product_tax: '',
      product_off_is_percent: '',
      text_input_searcher: null,
      pay_type_items: [],
      selected_pay_type: 0,
      total_price: 0,
      total_weight: 0,
      details: [],
      cashiers: [],
      selected_cashiers: 0,
      selected_cashiers_pos: 0,
      permission_group_items: [],
      selected_permission_group: 0,
      document_visitor: null,
      async_visitor_search: true,
      async_visitor_options: [],
      unit_items: [],
      unit_items_filtered: [],
      selected_place: 0,
      places_items: [],

      selected_product: null,
      status_product_form: -1,
      status_form: 0,
      master_id: 0,
      normalizer_products(node) {
        return {
          id: node.id,
          label: node.productCodeName,

        }
      },

      load_persons({action, searchQuery, callback}) {
        var self = this;
        if (action === ASYNC_SEARCH && searchQuery.length >= 3) {

          simulateAsyncOperation(() => {
            let options;
            const formData = new FormData();

            formData.append('SearchTxt', searchQuery);
            var url = "GetAllPersons";

            formData.append('IsVendor', false);
            formData.append('IsWorker', false);
            formData.append('IsCustomer', true);
            formData.append('IsActive', 0);

            axios.post(url, formData, {show_pros: true}).then(function (response) {
              options = response.data.data;

              callback(null, options);

            })
                .catch(function (error) {

                  console.log(error);
                });
          })
        }
      },
      load_visitors({action, searchQuery, callback}) {
        var self = this;
        if (action === ASYNC_SEARCH && searchQuery.length >= 3) {

          simulateAsyncOperation(() => {
            let options;
            const formData = new FormData();

            formData.append('SearchTxt', searchQuery);
            var url = "GetAllPersons";

            formData.append('IsVendor', false);
            formData.append('IsWorker', true);
            formData.append('IsCustomer', false);
            formData.append('IsActive', 0);

            axios.post(url, formData, {show_pros: true}).then(function (response) {
              options = response.data.data;
              callback(null, options);
            })
                .catch(function (error) {
                  console.log(error);
                });


          })
        }
      },
      normalizer_persons(node) {
        return {
          id: node.userId,
          label: node.personCode + " " + node.userName + " " + node.surName + " " + node.mobileNo,

        }
      },

    }
  },
  computed: {

    data_units() {
      var units_data = [];
      this.unit_items_filtered.forEach((val) => {
        var obj = {label: val.unitName, value: val.id}
        units_data.push(obj);
      });
      return units_data;
    },

    get_document_type_label() {
      if (this.selectedType == 1) {
        return this.$t('components.buyDocument');
      }
      if (this.selectedType == 3) {
        return this.$t('components.sellDocument');

      }
      if (this.selectedType == 5) {
        return this.$t('components.firstDocument');
      }

    }
  },
  created() {
    var self = this
    this.key_handler = function (e) {
      if(e.code=="F2"){
        self.insert_data_factor();
      }
    }
    window.addEventListener('keyup', this.key_handler);
  },
  beforeDestroy() {
    window.removeEventListener('keyup', this.key_handler);
  },
  mounted() {

    // console.log(document.getElementById("product_seeker").children[0].children[0].children[1].children[0]);
    // this.selectedType = this.$route.params.type_id
    this.$root.root_validate_errors = [];
    this.date = this.get_today();
    if(new Date(this.date) > new Date(this.fyear_max_date)){
      this.date = this.fyear_max_date
    }
    bus.$on('close_add_base_modal', (data) => {
      this.get_base_data();
    });
    this.get_base_data();
    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        // this.cancel_edit_product()

        this.status_product_form = -1;
      }
    });
    bus.$on('update_price', (data) => {
      // alert(data);
      if (data == "true") {
        this.$router.push({path: "/dashboard/products/edit-price/" + this.added_product});

      } else {
        this.status_form = 0;
      }
    });

    if (this.$route.params.user_id != null) {
      this.status_form = this.$route.params.user_id;
      this.get_user_data();
    }

    if (this.$route.params.edit_doc_id != null) {
      this.status_form = this.$route.params.edit_doc_id;
      this.get_document_master();
    }
  },
  watch: {
    'new_customer_mobile': function () {
      this.new_customer_name = this.new_customer_mobile
    },
    'selectedType': function () {
      if (this.selectedType == 1) {
        this.selectedTypeLabel = this.$t('components.seller');
        this.customer_doc_name = this.$t('supplier');
        this.selectedTypeQty = 1;
      }
      if (this.selectedType == 3) {
        this.selectedTypeLabel = this.$t('components.buyer');
        this.customer_doc_name = this.$t('customer');

        this.selectedTypeQty = -1;

      }
      if (this.selectedType == 5) {
        this.selectedTypeLabel = this.$t('components.employee');
        this.customer_doc_name = this.$t('user');

        this.selectedTypeQty = 1;

      }
    },
    '$route.params.type_id': function () {
      location.reload()
    },
    'product_price': function () {
      if (this.product_price == ".") {
        this.product_price = "0."
      }
    },
    'product_count': function () {
      if (this.product_count == ".") {
        this.product_count = "0."
      }
    },

    'selected_product': function () {
      // this.get_product_data()
    },
    'document_person': function () {
      if(this.document_person!=null){
        this.get_user_data();
        this.get_person_remaining_amount()
      }

    },
    'delivery_cost_amount': function () {
      this.calculate_price_result();
    },
    'sec_cost_amount': function () {
      this.calculate_price_result();
    },
    'total_factor_off': function () {

      this.calculate_price_result();
    },
    'total_factor_off_type': function () {
      this.calculate_price_result();
    },
    'total_price': function () {
      this.cashier_payment = 0
      this.pos_pay = this.total_price
    },
    'pos_pay': function () {
      this.cashier_payment = this.total_price - this.pos_pay
    },
    'cashier_payment': function () {
      this.pos_pay = this.total_price - this.cashier_payment
    },

    'product_items': function () {
      this.calculate_price_result()
    },

  },
  methods: {

    send_price_to_pos() {
      let bank_id = this.cashiers.filter(x => x.value == this.selected_cashiers_pos)[0].bankId
      if(bank_id==1){
        this.send_meli_pos()
        return false
      }
      if(bank_id==7){
        this.send_pasargad_pos()
        return false
      }

    },
    send_pasargad_pos() {

      let ip = this.cashiers.filter(x => x.value == this.selected_cashiers_pos)[0].terminalIP
      let port = this.cashiers.filter(x => x.value == this.selected_cashiers_pos)[0].terminalPort
      const pay_price = this.pos_pay;
      var url = 'http://127.0.0.1:9000/V1/sale';

      let formData = new FormData();
      formData.append('Price', pay_price.toString());
      formData.append('ComPort', 'Com2');
      formData.append('EvoucheOperator', '1');
      formData.append('BillID', '545454521');
      formData.append('BillPaymentID', '124476891');
      formData.append('IsLan', 'True');
      formData.append('Ip', ip);
      formData.append('Port', port);
      formData.append('PbmPic', 'null');

      fetch(
          url,

          {
            headers: {
              'Accept': 'application/json',

            },
            method: "POST",
            body: formData
          }).then(function (res) {
        return res.json()
      }).then(function (json) {
        console.log("return pc pos", json, json.errorCode)

      })
          .catch(function (res) {
            console.log(res)
          })
    },
    send_meli_pos() {

      // let ip = this.cashiers.filter(x => x.value == this.selected_cashiers_pos)[0].terminalIP
      // let port = this.cashiers.filter(x => x.value == this.selected_cashiers_pos)[0].terminalPort
      const pay_price = this.pos_pay;
      var url = 'SendToSadadPos';

      let formData = new FormData();
      formData.append('Amount', pay_price.toString());
      formData.append('TerminalId',  this.selected_cashiers_pos);
      var json_data = {
        Amount:pay_price.toString(),
        TerminalId:this.selected_cashiers_pos
      }
      axios.post(url, json_data, {}).then(function (response) {


      })
          .catch(function (error) {

            console.log(error);
          });
    },
    add_w_barcode_to_factor(wb_item) {
      var self = this

      var node = wb_item
      var lenght_duplicate = self.product_items.filter(x => x.product_id == node.id).length

      if (lenght_duplicate > 0) {
        self.product_items.forEach(function (val, index) {
          if (val.product_id == node.id) {
            Vue.set(val, 'count', parseInt(val.count) + 1)
            Vue.set(self.product_items, index, val)
            // val.count = val.count + 1
            if (self.status_form != 0) {
              self.status_product_form = val.product_id
              self.edit_factor_product(self.status_product_form)

            }
          }
        })
        self.barcode_model = ""
        document.getElementById('barcode_model').focus();
        document.getElementById('barcode_model').select();

        return;
      }
      console.log("node is", node)
      self.selected_product = node.id

      self.product_name = node.productCodeName;
      self.product_existance = node.existence;
      self.product_weight = node.weight;
      self.product_tax = node.vat;
      self.product_off_is_percent = node.isPercent;
      self.product_unit = node.productUnitId;
      self.product_unit_name = node.productUnitName;
      self.product_unit_value = node.value;
      self.product_count = 1;
      self.product_non_off = node.nonOff;
      if (node.guildPrice != 0) {
        self.product_price = node.guildPrice;
        self.product_off = node.takhfif;

      } else {
        if (self.delivery_type == 22) {
          self.product_price = node.retailPrice;
          self.product_off = node.retailDiscount;

        } else {
          self.product_price = node.salePrice;
          self.product_off = node.takhfif;

        }

      }

      if (self.product_price == 0) {
        console.log("price is zero")
        self.product_price = node.customerPrice
      }
      if (self.product_non_off) {
        self.product_off = 0;
      }

      self.add_product_to_document_new()


    },

    search_barcode() {
      const formData = new FormData();
      var self = this;
      formData.append('SearchTxt', self.barcode_model);
      if (self.document_person != null) {
        formData.append('PersonId', self.document_person);
      }
self.barcode_model = ""
      axios.post('GetProducts', formData, {}).then(function (response) {

        if (response.data.data.length != 1) {
          self.$root.root_validate_errors=[]
          self.$root.root_validate_errors.push(self.$t('ProductNotFound'));
          return
        }
        var node = response.data.data[0]
        var lenght_duplicate = self.product_items.filter(x => x.product_id == node.id).length

        if (lenght_duplicate > 0) {
          self.product_items.forEach(function (val, index) {
            if (val.product_id == node.id) {
              self.last_row_updated=index
              Vue.set(val, 'count', parseInt(val.count) + 1)
              Vue.set(self.product_items, index, val)
              // val.count = val.count + 1
              if (self.status_form != 0) {
                self.status_product_form = val.product_id
                self.edit_factor_product(self.status_product_form,val)

              }
            }
          })
          self.barcode_model = ""
          document.getElementById('barcode_model').focus();
          document.getElementById('barcode_model').select();

          return;
        }
        console.log("node is", node)
        self.selected_product = node.id

        self.product_name = node.productCodeName;
        self.product_existance = node.existence;
        self.product_weight = node.weight;
        self.product_tax = node.vat;
        self.product_off_is_percent = node.isPercent;
        self.product_unit = node.productUnitId;
        self.product_unit_name = node.productUnitName;
        self.product_unit_value = node.value;
        self.product_count = 1;
        self.product_non_off = node.nonOff;
        if (node.guildPrice != 0) {
          self.product_price = node.guildPrice;
          self.product_off = node.takhfif;

        } else {
          if (self.delivery_type == 22) {
            self.product_price = node.retailPrice;
            self.product_off = node.retailDiscount;

          } else {
            self.product_price = node.salePrice;
            self.product_off = node.takhfif;

          }

        }

        if (self.product_price == 0) {
          console.log("price is zero")
          self.product_price = node.customerPrice
        }
        if (self.product_non_off) {
          self.product_off = 0;
        }

        self.add_product_to_document_new("barcode")

      })
          .catch(function (error) {

            console.log(error);
          });
    },
    load_products({action, searchQuery, callback}) {

      if (action === ASYNC_SEARCH) {
        simulateAsyncOperation(() => {
          const formData = new FormData();

          formData.append('SearchTxt', searchQuery);
          if (this.document_person != null) {
            formData.append('PersonId', this.document_person);
          }

          axios.post('GetProducts', formData, {show_pros: true}).then(function (response) {
            callback(null, response.data.data);
            // callback(null, []);
            response = null
          })
              .catch(function (error) {
                console.log(error);
              });

        })
      }
    },

    select_person(node) {
      var valid = true;
      console.log("node vperson is ", node.isBlackList, node.pStatusId);
      if (node.isBlackList == 39) {
        this.$root.root_validate_errors.push(this.$t('isInBlacklist'));
        valid = false;
      }
      if (node.pStatusId == 40) {
        this.$root.root_validate_errors.push(this.$t('isDectivated'));
        valid = false;

      }
      var self = this;

      if (!valid) {
        setTimeout(function () {
          self.document_person = null;
        }, 200);
      }
    },

    calculate_price_result() {
      this.total_price = 0;
      var total_off = 0;
      var total_tax = 0;
      var total_pay_price = 0;
      this.total_weight = 0;
      var factor_off = 0;
      if (this.total_factor_off_type == 1 && this.total_factor_off != '') {
        // total_off = parseFloat(this.total_factor_off);
        factor_off = parseFloat(this.total_factor_off);
      }

      this.document_result_price = [];
      this.product_items.forEach((val) => {
        if (val.name != null) {
          console.log('products ', val)

          total_off += this.calculate_off_price(val);
          total_tax += this.calculate_tax_price(val);
          total_pay_price += this.calculate_total_price(val);
          this.total_price += this.calculate_total_pay_price(val);
          this.total_weight += (parseFloat(val.count) * val.weight * val.unit_value);
          if (this.total_factor_off_type == 2 && val.non_off == false && this.total_factor_off_type != 0 && this.total_factor_off != '') {
            // total_off += (parseFloat(this.total_factor_off)*this.calculate_total_price(val))/100;
            console.log("calculate_price_result called" ,factor_off,val.product_off)

            if (val.product_off == '0' || val.product_off == '' || val.product_off == '0.00') {
              console.log("calculate_price_result called" ,factor_off,val.product_off)

              factor_off += (parseFloat(this.total_factor_off) * this.calculate_total_price(val)) / 100;
            }

          }
        }
      });
      this.total_price = parseFloat(this.total_price);
      if (this.delivery_cost_amount != null && this.delivery_cost_amount != "") {
        this.total_price += parseFloat(this.delivery_cost_amount);
      }
      if (this.sec_cost_amount != null && this.sec_cost_amount != "") {
        this.total_price += parseFloat(this.sec_cost_amount);
      }
      // this.total_weight = this.total_weight.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      var obj = {
        totalTitle: this.$t('totalPrice'),
        totalPrice: this.currency_with_symbol(total_pay_price),
        offPrice: total_off,
        afterOffPrice: total_pay_price - total_off,
        taxPrice: total_tax,
        factor_off: factor_off,
        payPrice: this.currency_with_symbol(this.total_price - factor_off),
        beforePrice: 0,
        total_weight: this.total_weight,
        finalPrice: 0 + parseInt(this.total_price)
      };
      this.document_result_price.push(obj)

    },
    cancel_edit_product() {
      this.selected_product = null;
      this.product_count = '';
      this.product_price = '';
      this.product_off = '';
      this.product_tax = '';
      this.status_product_form = -1;
    },
    open_selected_product() {
      window.open('/dashboard/products/edit/' + this.selected_product, '_blank')
    },
    another_focus(id) {
      setTimeout(function () {
        document.getElementById(id).focus()
        document.getElementById(id).select()

      }, 200);
    },
    get_person_remaining_amount() {
      var self = this;
      const formData = new FormData();

      formData.append('FromDate', moment().locale('en').format('YYYY-MM-DD'));
      formData.append('ToDate', moment().locale('en').format('YYYY-MM-DD'));
      var url = ""
      url = "GetLastPartyAccountByParam"

      formData.append('TafsiliType', 2);


      formData.append('id', 0);

      formData.append('PartyId', this.document_person);
      formData.append('ParentId', 10);
      formData.append('ChildId', 10);
      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.document_person_remain_amount = response.data.data.balance


          // response.data.data.balance
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }
      })
          .catch(function (error) {

            console.log(error);
          });

    },

    get_base_data() {
      this.get_places();
      this.get_default_customer();
      this.get_cashiers();
      this.get_product_units();
      this.get_costs();
      this.get_sys();
      this.get_products_w_barcode();
    },
    get_products_w_barcode() {
      var self = this;

      const formData = new FormData();

      axios.post('GetProductsWBarcode', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.data != null) {

          self.products_w_barcode = content_data.data
          self.products_w_barcode.sort((a, b) => a.productName.localeCompare(b.productName, undefined, {
            numeric: true,
            sensitivity: 'base'
          }));

        }

      })
          .catch(function (error) {
            console.log(error);
          });

    },
    get_default_customer() {
      var self = this;

      const formData = new FormData();

      axios.post('GetDefaultCustomer', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.data != null) {
          content_data.data.userId = content_data.data.personId;
          content_data.data.userName = content_data.data.personName;
          self.document_person = content_data.data.personId;

          // id: node.userId,
          //     label: node.personCode + " " + node.userName + " " + node.surName + " " + node.mobileNo,

          self.async_person_search = false;
          self.async_person_options = [content_data.data]
          setTimeout(function () {
            self.async_person_search = true;

          }, 300)

        }

      })
          .catch(function (error) {
            console.log(error);
          });

    },
    add_new_customer() {
      var self = this;

      const formData = new FormData();

      var person = {
        "Person": {
          "Title": 1,
          "PersonId": 0,
          "MiddelName": "",
          "SurName": "",
          "PersonTitle": "",
          "PersonName": this.new_customer_name,
          "PersonCode": "",
          "NationalCode": "",
          "MobileNo": "",
          "PhoneNo": "",
          "IsWorker": false,
          "IsCustomer": true,
          "IsVendor": false,
          "GuildUnitTitleId": 1002,
          "Porsant": "0",
          "PStatus": 39,
          "IsBlackList": 40
        },
        "PersonAddress": [{
          "CountryId": 1,
          "ProvinceId": 7,
          "CityId": 770,
          "RegionId": 2076,
          "postCode": "",
          "AreaRelId": 0,
          "AddressText": "تهران",
          "Lat": 0,
          "Lng": 0
        }, {
          "CountryId": 1,
          "ProvinceId": 0,
          "CityId": 0,
          "RegionId": 0,
          "postCode": "",
          "PhoneNo": "",
          "AreaRelId": 0,
          "AddressText": "",
          "Lat": 0,
          "Lng": 0
        }],
        "PersonContacts": [{"ContactType": 19, "Contact": this.new_customer_mobile}, {
          "ContactType": 18,
          "Contact": ""
        }, {"ContactType": 63, "Contact": ""}],
        "UserDepartemans": [],
        "PersonExtraInfo": {
          "Gender": 4,
          "PersonTypeId": 37,
          "BirthData": "",
          "BimeNumber": 0,
          "MaritalStatus": 7,
          "Citizenship": "",
          "CategoryId": 0,
          "EconomicCode": "",
          "CompanyCode": "",
          "Assessment": 61,
          "OtherLanguage": "",
          "Education": 48,
          "Skills": "",
          "ResidentialStatus": 9,
          "NationalCode": ""
        },
        "PersonBankInfo": {"BankId": 6, "AccountName": "", "AccountNo": 0, "SortCode": 0, "Iban": 0},
        "PersonEmrgencyContact": {
          "Name": "",
          "SurName": "",
          "Relationship": 41,
          "Mobile": "",
          "TrainingCourses": "",
          "DisabilityStatus": ""
        },
        "PersonJobProfile": {
          "EmploymentDate": "",
          "ContractNumber": 0,
          "CooperationType": 11,
          "LeaversDate": "",
          "ReasonsForLeaving": "",
          "Benefit": "",
          "PensionStartDate": "",
          "wage": 0,
          "shift": 29,
          "hours": "",
          "paymentFrequency": 0,
          "Credit": "",
          "SaleType": 0,
          "paymentMethod": 58
        },
        "PeopleInfos": [],
        "UserGroup": {"GroupRecId": 0}
      }
      // formData.append('PersonModule', JSON.stringify(person));
      formData.append('username', this.new_customer_mobile);
      formData.append('mobileNo', this.new_customer_mobile);

      axios.post('AddCustomerNew', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.data != null) {
          content_data.data.userId = content_data.data.id;
          content_data.data.userName = self.new_customer_name;
          content_data.data.mobileNo = self.new_customer_mobile;
          content_data.data.personCode = "";
          content_data.data.surName = "";
          self.document_person = content_data.data.userId;

          // id: node.userId,
          //     label: node.personCode + " " + node.userName + " " + node.surName + " " + node.mobileNo,

          self.new_customer_modal = false;
          self.async_person_search = false;
          self.async_person_options = [content_data.data]
          setTimeout(function () {
            self.async_person_search = true;

          }, 300)

        }

      })
          .catch(function (error) {
            console.log(error);
          });

    },
    get_costs() {
      var self = this;

      const formData = new FormData();

      axios.post('GetDeliveryCostItems', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {

          var array = [];
          for (var i = 0; i < content_data.data.length; i++) {
            if (i > 0) {
              array.push(content_data.data[i]);
            }
          }
          self.cost_items = self.sort_array(self.cost_items, array, "id", "deliveryCostTitle");
          self.selected_first_cost = self.cost_items[0].value;
          self.selected_sec_cost = self.cost_items[0].value;
        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }


      })
          .catch(function (error) {
            console.log(error);
          });

    },
    get_sys() {
      var self = this;

      const formData = new FormData();

      axios.post('GetSysPersonGlobals', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;

        self.pay_type_items = [];
        self.delivery_type_items = [];


        content_data.forEach((val) => {
          var obj = {label: val.title, value: val.id}

          if (val.titleType == 26) {
            self.pay_type_items.push(obj);
          }
          if (val.titleType == 9) {
            self.delivery_type_items.push(obj);
          }

        });

        if (self.get_access("all_factor_nesie")) {
          self.selected_pay_type = 35

        } else {
          self.selected_pay_type = self.pay_type_items[0].value

        }
        self.delivery_type = self.delivery_type_items[0].value


      })
          .catch(function (error) {

            console.log(error);
          });

    },

    go_to_add_modal(func) {
      bus.$emit("show_add_base_modal", func);
    },
    get_cashiers() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);

      axios.post('GetTafsiliesForCash', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.cashiers = self.sort_array(
              self.cashiers, response.data.data,
              'id', 'boxTitle');
          // self.cashiers = self.cashiers.filter(x => x.accountId == 70);
          self.selected_cashiers = self.cashiers.filter(x => x.isCashier)[0].value
          self.selected_cashiers_pos = self.cashiers.filter(x => x.isCashier == false)[0].value
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    select_product(node, instance) {
      var lenght_duplicate = this.product_items.filter(x => x.product_id == node.id).length
      if (lenght_duplicate > 0) {
        this.$root.root_validate_errors.push(this.$t('dialogs.duplicateProduct'));
      }

      console.log("node is", node)
      this.product_name = node.productCodeName;
      this.product_existance = node.existence;
      this.purchase_price = node.lastPurchasePrice;
      this.product_weight = node.weight;
      this.product_tax = node.vat;
      this.product_off_is_percent = node.isPercent;
      this.product_unit = node.productUnitId;
      this.product_unit_name = node.productUnitName;
      this.product_unit_value = node.value;
      this.product_count = 1;
      this.product_non_off = node.nonOff;
      if (node.guildPrice != 0) {
        this.product_price = node.guildPrice;
        this.product_off = parseFloat(node.takhfif).toFixed(2);

      } else {
        if (this.delivery_type == 22) {
          this.product_price = node.retailPrice;
          this.product_off = parseFloat(node.retailDiscount).toFixed(2);

        } else {
          this.product_price = node.salePrice;
          this.product_off = parseFloat(node.takhfif).toFixed(2);

        }

      }
      console.log("price is zero", this.product_price)

      if (this.product_price == 0) {
        console.log("price is zero")
        this.product_price = node.customerPrice
      }
      if (this.product_non_off) {
        this.product_off = 0;
      }

      setTimeout(function () {
        document.getElementById('product_qty_input').focus()

        document.getElementById('product_qty_input').select();
      }, 150);

    },
    table_row_clicked(item, index, column, event) {
      if (event.watch == 3) {

        console.log(event);
        this.product_index_clicked = index;
        var self = this;
        setTimeout(function () {
          // self.$refs.menu.open(self.mouse_position,null)
          self.$refs.menu.open(event, null)

          // var obj = self.$refs.dropdown_menu.$el.getElementsByTagName('button')[0]
        }, 150);
      }
    },
    calculate_total_price(item) {
      // console.log('calc total',item);
      return item.price * item.count //* item.unit_value;
    },
    calculate_off_price(item) {
      var off = 0
      // if(item.product_off_is_percent == true) {
      off = (item.product_off * (this.calculate_total_price(item)) / 100);
      // } else {
      //   off= item.product_off * item.count * item.unit_value;

      // }
      if (off) {
        return off;
      } else {
        return 0;
      }
    },
    calculate_tax_price(item) {
      // return parseInt(item.product_tax * item.count * item.unit_value);
      var tax = (item.product_tax * (this.calculate_total_price(item) - this.calculate_off_price(item))) / 100;
      if (!tax) {
        return 0;
      } else {
        return tax;
      }


    },
    calculate_total_pay_price(item) {

      var off = parseFloat(this.calculate_off_price(item));

      var tax = parseFloat(this.calculate_tax_price(item));
      console.log("tax ", tax, " off ", off, "total", this.calculate_total_price(item) - off + tax)
      return this.calculate_total_price(item) - off + tax
    },
    validateForm: function () {
      this.$root.root_validate_errors = [];


      if (this.date != '' && this.selected_place != 0 && this.document_person != null && this.product_items.length > 1) {
        return true;


      }

      if (this.date == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertDate'));
      }
      if (this.selected_place == 0) {
        this.$root.root_validate_errors.push(this.$t('dialogs.selectWarehouse'));
      }
      if (this.document_person == null) {
        this.$root.root_validate_errors.push(this.selectedTypeLabel + this.$t('dialogs.select'));
      }
      if (this.this.product_items.length == 0) {
        this.$root.root_validate_errors.push(this.$t('dialogs.selectProducts'));
      }

      return false;
      // e.preventDefault();
    },
    validateProduct: function (barcode) {
      this.$root.root_validate_errors = [];
      var duplicate_product = false;
      this.product_items.forEach((val) => {
        if (barcode == null && val.product_id == this.selected_product && this.status_product_form == -1) {
          this.$root.root_validate_errors.push(this.$t('dialogs.duplicateProduct'));
          duplicate_product = true;

        }
        // val.row_id = row_index;
        // row_index += 1;
      });


      if (this.product_name != '' && this.product_price != '' && this.product_price != null && this.product_price != '0' && this.product_count != '' && this.product_count != 0 && !duplicate_product) {
        return true;
      }

      // if (this.product_name == '') {
      //   this.$root.root_validate_errors.push(this.$t('dialogs.insertName'));
      // }
      if (this.product_price == '' || this.product_price == '0' || this.product_price == null) {
        this.$root.root_validate_errors.push(this.$t('insertProductPrice'));
      }
      if (this.product_count == '' || this.product_count == "0") {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertProductQty'));
      }

      return false;
      // e.preventDefault();
    },
    get_style(color) {
      return {
        myStyle: {
          backgroundColor: color
        }
      }
    },
    add_product_to_document_new(barcode) {
      this.$root.root_validate_errors = [];
      console.log("add_product_to_document_new",this.product_count,(this.product_existance / this.product_unit_value))
      if ((this.product_existance / this.product_unit_value) < this.product_count && !this.get_access("negative_stock")) {
        this.$root.root_validate_errors.push(this.$t('OutOfStock'));

        return;
      }
      if (this.get_access('purchase_price_in_factor') && parseFloat(this.product_price) < parseFloat(this.purchase_price)) {
        console.log("purchase_price_in_factor", parseFloat(this.purchase_price), this.product_price)
        this.$root.modal_component.show_danger_modal(this.$t("dialogs.error"), this.$t("dialogPriceIsBelowPurchasePrice"));
        // return;
      }
      if (this.status_product_form != -1) {
        this.update_product_to_document();
        return
      }
      // console.log("validate is ", this.validateProduct(barcode))
      if (this.validateProduct(barcode)) {

        var product_new_item = [];
        // this.unit_items.forEach((val) => {
        //   if (val.id == this.product_unit) {
        //     product_new_item.unit_value = val.value;
        //     product_new_item.unit_value_name = val.unitName;
        //   }
        //   // val.row_id = row_index;
        //   // row_index += 1;
        //
        // });
        product_new_item.unit_value_name = "";
        product_new_item.unit_value = this.product_unit_value;
        product_new_item.name = this.product_name;
        product_new_item.non_off = this.product_non_off;
        product_new_item.unit = this.product_unit;
        product_new_item.count = this.product_count;
        product_new_item.price = this.product_price;
        product_new_item.summary = this.product_summary;
        product_new_item.weight = this.product_weight;
        product_new_item.product_id = this.selected_product;
        product_new_item.product_off = this.product_off;
        product_new_item.product_tax = this.product_tax;
        product_new_item.product_off_is_percent = this.product_off_is_percent;

        product_new_item.totalPrice = this.calculate_total_price(product_new_item);
        product_new_item.offPrice = this.calculate_off_price(product_new_item);
        product_new_item.taxPrice = this.calculate_tax_price(product_new_item);
        product_new_item.totalPayPrice = this.calculate_total_pay_price(product_new_item);

        console.log('product is ', product_new_item)
        this.product_items.push(product_new_item);
        this.product_name = "";
        this.product_non_off = false;
        this.product_unit = "";
        this.product_off = "";
        this.product_tax = "";
        this.product_count = "";
        this.product_summary = '';
        this.product_price = "";
        this.selected_product = null;

        var row_index = 0;
        console.log("products items",this.product_items)
        this.product_items.forEach((val) => {
          val.row_id = row_index;
          this.last_row_updated = row_index

          row_index += 1;
        });
        if (this.status_form != 0) {
          this.add_one_factor_product(this.product_items.length - 1);
        }

        if (barcode == null) {


          this.text_input_searcher = document.getElementById("product_seeker").children[0]

          this.text_input_searcher.focus();

        } else {
          this.barcode_model = ""
          document.getElementById('barcode_model').focus();
          document.getElementById('barcode_model').select();

        }
      }
    },
    update_product_to_document() {
      if (this.validateProduct()) {
        // this.status_product_form = -1;
        var product_new_item = [];
        // this.unit_items.forEach((val) => {
        //   if (val.id == this.product_unit) {
        //
        //   }
        //   // val.row_id = row_index;
        //   // row_index += 1;
        //
        // });
        product_new_item.unit_value = this.product_unit_value;
        product_new_item.unit_value_name = "";
        // product_new_item.unit_value = 1;

        if (this.status_product_form != -1) {
          // product_new_item.detail_id = this.product_items[this.status_product_form].detail_id;
          product_new_item.detail_id = this.product_items.filter(x => x.product_id == this.status_product_form)[0].detail_id;

        }
        product_new_item.name = this.product_name;
        product_new_item.non_off = this.product_non_off;
        product_new_item.unit = this.product_unit;
        product_new_item.count = this.product_count;
        product_new_item.price = this.product_price;
        product_new_item.summary = this.product_summary;
        product_new_item.weight = this.product_weight;
        product_new_item.product_id = this.selected_product;
        product_new_item.product_off = this.product_off;
        product_new_item.product_tax = this.product_tax;
        product_new_item.product_off_is_percent = this.product_off_is_percent;
        console.log("on edit product", product_new_item)
        if (this.status_form == 0) {

          this.product_items.forEach((val, index) => {
            if (val.product_id == this.status_product_form) {
              this.product_items.splice(index, 1, product_new_item);
            }
          });

          this.product_name = "";
          this.product_non_off = false;
          this.product_unit = "";
          this.product_count = "";
          this.product_summary = '';
          this.product_off = "";
          this.product_tax = "";
          this.product_price = 0;
          this.selected_product = null;
          var row_index = 0;
          this.product_items.forEach((val) => {
            val.row_id = row_index;
            row_index += 1;

          });
        }
        // this.product_items.splice(this.status_product_form, 1, product_new_item);

        if (this.status_form != 0) {
          this.edit_factor_product(this.status_product_form,product_new_item)

        } else {
          this.status_product_form = -1;

        }
      }
    },
    edit_item(index) {

      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      var product_new_item = this.product_items.filter(x => x.product_id == index)[0];
      console.log("item_edit", product_new_item)
      this.product_name = product_new_item.name;
      this.product_non_off = product_new_item.non_off;
      this.product_unit = product_new_item.unit;
      this.product_unit_value = product_new_item.unit_value;
      this.product_count = product_new_item.count;
      this.product_weight = product_new_item.weight;
      this.product_price = parseFloat(product_new_item.price).toFixed(2);
      this.product_summary = product_new_item.summary;
      this.product_off = parseFloat(product_new_item.product_off).toFixed(2);
      this.product_tax = parseFloat(product_new_item.product_tax).toFixed(2);
      this.product_off_is_percent = product_new_item.product_off_is_percent;
      this.selected_product = product_new_item.product_id;
      this.status_product_form = index;
      this.get_product_data()
    },
    get_product_data() {

      let self = this;
      const formData = new FormData();
      let url;
      url = "GetNewProductById";

      formData.append('id', this.selected_product);
      axios.post(url, formData, {}).then((res) => {


        self.product_existance = res.data.data.existence

        try {
          self.product_weight = res.data.data.productExtraInfos.filter(x => x.productId == self.selected_product)[0].weight;

        } catch (e) {

        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    emptyList() {
      // this.$router.push({path: '/dashboard/products/list'})
      // this.$forceUpdate();
      bus.$emit('reload_invoice_component', true);
    },
    get_places() {
      var self = this;
      self.places_items = [];
      this.$apis.get_places().then(result => {
        self.places_items = result
        self.selected_place = self.places_items[0].value;

      })


    },
    get_product_units() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetProductUnits', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {

          self.unit_items = content_data.data;


        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_user_data() {

      let self = this;
      const formData = new FormData();
      let url;
      url = "GetPersonById";

      formData.append('id', this.document_person);


      axios.post(url, formData, {}).then((res) => {

        if (res.data.data.personJobProfile.paymentMethod == 58 && self.status_form == 0) {
          self.selected_pay_type = 34;
        }
        if (res.data.data.personJobProfile.paymentMethod == 59 && self.status_form == 0) {
          self.selected_pay_type = 35;
        }
        self.document_person_method_name = res.data.data.methodName;
        self.document_person_credit = res.data.data.personJobProfile.credit;


      })
          .catch(function (error) {

            console.log(error);
          });


    },

    insert_supermarket_factor() {
      if (!this.validateForm()) {
        return true;
      }

      let self = this;
      const formData = new FormData();
      let url;

      if (this.status_form == 0) {
        url = "AddShopFactor";
      }


      // PayType
      //
      var json_cost = [];
      if (this.delivery_cost_amount != '' && this.delivery_cost_amount != '0') {
        json_cost.push({DeliveryCostId: 1, DeliveryCostPrice: this.delivery_cost_amount});
      }
      if (this.sec_cost_amount != '' && this.sec_cost_amount != '0') {
        json_cost.push({DeliveryCostId: this.selected_sec_cost, DeliveryCostPrice: this.sec_cost_amount});
      }

      formData.append('Master.PayType', this.selected_pay_type);
      formData.append('Master.AccountId', this.selected_cashiers);
      formData.append('Master.BaseFactorId', 0);
      formData.append('Master.CurrencyId', 0);
      formData.append('Master.PayTypePercent', this.off_over_nesie);
      formData.append('Master.CurrencyRate', 1);
      formData.append('Master.DocDate', this.date);
      formData.append('Master.PartyId', this.document_person);
      formData.append('Master.PlaceId', this.selected_place);
      formData.append('Master.DocType', this.selectedType);
      formData.append('Master.DeliveryType', this.delivery_type);
      formData.append('Master.DocDesc', this.document_summary);
      formData.append('Master.FactorDiscountType', this.total_factor_off_type);
      var total_percent_price_off = 0;
      if (this.total_factor_off == '') {
        this.total_factor_off = '0';
      }
      if (this.total_factor_off_type == 2) {
        this.product_items.forEach((val) => {
          if (val.name != null) {
            if (val.non_off == false && this.total_factor_off != '') {
              total_percent_price_off += (parseFloat(this.total_factor_off) * this.calculate_total_price(val)) / 100;
            }
          }
        });
        formData.append('Master.FactorDiscount', total_percent_price_off);

      } else {
        formData.append('Master.FactorDiscount', this.total_factor_off);

      }

      formData.append('Master.DeliveryCostList', JSON.stringify(json_cost));
      //add detail
      var sending_products = [];
      var pr_index = 0;
      self.product_items.forEach((val) => {
        if (pr_index != 0) {
          var pro_obj = {
            MasterId: self.master_id,
            PlaceId: self.selected_place,
            ProductId: val.product_id,
            ProductUnitId: val.unit,
            Qty: val.count * self.selectedTypeQty,
            Price: val.price / val.unit_value,
            ProductDesc: val.summary,
            Tax: this.calculate_tax_price(val),
            Discount: this.calculate_off_price(val)
          };
          sending_products.push(pro_obj);
        }
        pr_index = 1;
      });
      var final_sending = {'details': sending_products};
      formData.append('Details', JSON.stringify(final_sending));
      //End add detail
      var pays = []
      pays.push({"PayType": 70, "ReceiverId": this.selected_cashiers, "Amount": this.cashier_payment})
      pays.push({"PayType": 77, "ReceiverId": this.selected_cashiers_pos, "Amount": this.pos_pay})

      //add Pays

      formData.append('Pays', JSON.stringify(pays));

      //end add pays
      axios.post(url, formData, {}).then((res) => {

        // self.get_lists();
        self.$root.modal_component.show_api_response_modals(res);
        if (this.status_form == 0) {


          self.$router.push({path: "/dashboard/documents/show/" + res.data.data.id})

        } else {
          self.$router.push({path: "/dashboard/documents/show/" + res.data.data.id})

        }


      })
          .catch(function (error) {
            console.log(error);
          });

    },
    insert_data_factor() {
      console.log('insert_data_factor called')
      if (!this.validateForm()) {
        return true;
      }

      let self = this;
      const formData = new FormData();
      let url;

      if (this.status_form == 0) {
        url = "AddFactor";
      } else {
        url = "EditFactorMaster";
        formData.append('Id', this.status_form)

      }

      // if (this.get_access('super_market_config')) {
      //   this.insert_supermarket_factor()
      //   return false
      // }
      // PayType
      //
      var json_cost = [];
      if (this.delivery_cost_amount != '' && this.delivery_cost_amount != '0') {
        json_cost.push({DeliveryCostId: 1, DeliveryCostPrice: this.delivery_cost_amount});
      }
      if (this.sec_cost_amount != '' && this.sec_cost_amount != '0') {
        json_cost.push({DeliveryCostId: this.selected_sec_cost, DeliveryCostPrice: this.sec_cost_amount});
      }

      formData.append('PayType', this.selected_pay_type);
      formData.append('AccountId', this.selected_cashiers);
      formData.append('BaseFactorId', 0);
      formData.append('CurrencyId', 0);
      formData.append('PayTypePercent', this.off_over_nesie);
      formData.append('CurrencyRate', 1);
      formData.append('DocDate', this.date);
      formData.append('PartyId', this.document_person);
      if(this.document_visitor!=null){
        formData.append('SalesmanId', this.document_visitor);

      }
      formData.append('PlaceId', this.selected_place);
      formData.append('DocType', this.selectedType);
      formData.append('DeliveryType', this.delivery_type);
      formData.append('DocDesc', this.document_summary);
      formData.append('FactorDiscountType', this.total_factor_off_type);
      var total_percent_price_off = 0;
      if (this.total_factor_off == '') {
        this.total_factor_off = '0';
      }
      if (this.total_factor_off_type == 2) {
        this.product_items.forEach((val) => {
          if (val.name != null) {
            if (val.non_off == false && this.total_factor_off != '') {
              total_percent_price_off += (parseFloat(this.total_factor_off) * this.calculate_total_price(val)) / 100;
            }
          }
        });
        formData.append('FactorDiscount', total_percent_price_off);

      } else {
        formData.append('FactorDiscount', this.total_factor_off);

      }

      formData.append('DeliveryCostList', JSON.stringify(json_cost));
      axios.post(url, formData, {}).then((res) => {

        // self.get_lists();
        self.$root.modal_component.show_api_response_modals(res);
        if (this.status_form == 0) {

          self.master_id = res.data.data.id;
          self.insert_factor_products();

          // self.product_items.forEach((val) => {
          //     self.insert_factor_products(index);
          //     index+=1;
          //
          // });

        } else {
          self.$router.push({path: "/dashboard/documents/show/" + self.status_form})

        }


      })
          .catch(function (error) {
            console.log(error);
          });

    },
    insert_factor_products() {

      let self = this;
      const formData = new FormData();
      let url;
      if (this.status_form == 0) {
        url = "AddFactorDetail";
      } else {
        url = "EditFactorDetail";
        formData.append('Id', this.status_form)

      }

      var sending_products = [];
      var pr_index = 0;
      self.product_items.forEach((val) => {
        if (pr_index != 0) {
          var pro_obj = {
            MasterId: self.master_id,
            PlaceId: self.selected_place,
            ProductId: val.product_id,
            ProductUnitId: val.unit,
            Qty: val.count * self.selectedTypeQty,
            Price: val.price / val.unit_value,
            ProductDesc: val.summary,
            Tax: this.calculate_tax_price(val),
            Discount: this.calculate_off_price(val)
          };
          sending_products.push(pro_obj);
        }
        pr_index = 1;
      });
      var final_sending = {'details': sending_products};
      formData.append('model', JSON.stringify(final_sending));
      // formData.append('PlaceId', this.selected_place);
      // formData.append('ProductId', this.product_items[index].product_id);
      // formData.append('ProductUnitId', this.product_items[index].unit);
      // formData.append('Qty', this.product_items[index].count * this.selectedTypeQty);
      // formData.append('Price', this.product_items[index].price);
      // formData.append('ProductDesc', this.product_items[index].summary);

      // formData.append('Color', this.color);
      // formData.append('description', this.description);
      axios.post(url, formData, {}).then((res) => {


        // self.get_lists();
        self.$root.modal_component.show_api_response_modals(res);
        if (self.status_form == 0) {
          if (res.data.statusCode == 0 && res.data.isSuccess) {

            self.date = "";
            self.document_person = null;
            self.document_summary = "";
            // if (index == self.product_items.length - 1) {
            self.product_items = [];
            self.selected_place = 0;

            self.name = "";
            self.meli_code = "";
            self.meli_code = "";
            self.mobile = "";
            self.phone_no = "";
            self.isWorker = false;
            self.isCustomer = false;
            self.isVendor = false;
            self.selected_province = 0;
            self.selected_city = 0;
            self.selected_area = 0;
            self.address = "";
            self.password = "";
            self.selected_permission_group = 0;
            self.user_location_lat = 0;
            self.user_location_lng = 0;
            self.$router.push({path: "/dashboard/documents/show/" + self.master_id})
          }
          // }else {
          // this.$router.push({path:'/dashboard/products/list'})
          // self.insert_factor_products(index+1);

          // }
        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    add_one_factor_product(index) {

      let self = this;
      const formData = new FormData();
      let url;
      url = "AddFactorDetail";

      var sending_products = [];
      // self.product_items.forEach((val) => {

      var pro_obj = {
        MasterId: self.status_form,
        PlaceId: self.selected_place,
        ProductId: self.product_items[index].product_id,
        ProductUnitId: self.product_items[index].unit,
        Qty: self.product_items[index].count * self.selectedTypeQty,
        Price: self.product_items[index].price / self.product_items[index].unit_value,
        ProductDesc: self.product_items[index].summary,
        Tax: this.calculate_tax_price(self.product_items[index]),
        Discount: this.calculate_off_price(self.product_items[index])
      };
      sending_products.push(pro_obj);
      // });
      var final_sending = {'details': sending_products};
      formData.append('model', JSON.stringify(final_sending));
      // formData.append('PlaceId', this.selected_place);
      // formData.append('ProductId', this.product_items[index].product_id);
      // formData.append('ProductUnitId', this.product_items[index].unit);
      // formData.append('Qty', this.product_items[index].count * this.selectedTypeQty);
      // formData.append('Price', this.product_items[index].price);
      // formData.append('ProductDesc', this.product_items[index].summary);

      // formData.append('Color', this.color);
      // formData.append('description', this.description);
      axios.post(url, formData, {}).then((res) => {


        // self.get_lists();
        self.$root.modal_component.show_api_response_modals(res);
        if (this.status_form == 0) {
          self.date = "";
          self.document_person = null;
          self.document_summary = "";
          // if (index == self.product_items.length - 1) {
          self.product_items = [];
          self.selected_place = 0;

          self.name = "";
          self.meli_code = "";
          self.meli_code = "";
          self.mobile = "";
          self.phone_no = "";
          self.isWorker = false;
          self.isCustomer = false;
          self.isVendor = false;
          self.selected_province = 0;
          self.selected_city = 0;
          self.selected_area = 0;
          self.address = "";
          self.password = "";
          self.selected_permission_group = 0;
          self.user_location_lat = 0;
          self.user_location_lng = 0;
          self.$router.push({path: "/dashboard/documents/show/" + self.master_id})
          // }else {
          // this.$router.push({path:'/dashboard/products/list'})
          // self.insert_factor_products(index+1);

          // }
        }else{
          self.product_items = [{id: "0"}]
            self.get_document_details()
        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    edit_factor_product(index,edited_product) {

      let self = this;
      const formData = new FormData();
      let url;
      url = "EditFactorDetail";

      // var edited_product = this.product_items.filter(x => x.product_id == this.status_product_form)[0];

      // });
      // var final_sending = {'details': sending_products};
      // formData.append('model', JSON.stringify(final_sending));
      formData.append('MasterId', self.status_form);
      formData.append('Id', edited_product.detail_id);
      formData.append('PlaceId', this.selected_place);
      formData.append('ProductId', edited_product.product_id);
      formData.append('ProductUnitId', edited_product.unit);
      formData.append('Qty', edited_product.count * this.selectedTypeQty);
      formData.append('Price', edited_product.price / edited_product.unit_value);
      formData.append('ProductDesc', edited_product.summary);
      formData.append('Tax', this.calculate_tax_price(edited_product));
      // formData.append('Tax', edited_product.product_tax);
      formData.append('Discount', this.calculate_off_price(edited_product));
      // formData.append('Discount', edited_product.product_off);
      formData.append('CurrencyId', 0);

      // formData.append('Color', this.color);
      // formData.append('description', this.description);
      axios.post(url, formData, {}).then((res) => {


        // self.get_lists();
        self.$root.modal_component.show_api_response_modals(res);
            if (res.data.statusCode == 0) {
              self.product_items.forEach((val, index) => {
                if (val.product_id == self.status_product_form) {
                  self.product_items.splice(index, 1, edited_product);
                }
              });
              self.status_product_form = -1;
              self.product_name = "";
              self.product_non_off = false;
              self.product_unit = "";
              self.product_count = "";
              self.product_summary = '';
              self.product_off = "";
              self.product_tax = "";
              self.product_price = 0;
              self.selected_product = null;
              var row_index = 0;
              self.product_items.forEach((val) => {
                val.row_id = row_index;
                row_index += 1;

              });
            }



        if (self.status_form == 0) {

          self.date = "";
          self.document_person = null;
          self.document_summary = "";
          // if (index == self.product_items.length - 1) {
          self.product_items = [];
          self.selected_place = 0;
          self.name = "";
          self.meli_code = "";
          self.meli_code = "";
          self.mobile = "";
          self.phone_no = "";
          self.isWorker = false;
          self.isCustomer = false;
          self.isVendor = false;
          self.selected_province = 0;
          self.selected_city = 0;
          self.selected_area = 0;
          self.address = "";
          self.password = "";
          self.selected_permission_group = 0;
          self.user_location_lat = 0;
          self.user_location_lng = 0;
          self.$router.push({path: "/dashboard/documents/show/" + self.master_id})
          // }else {
          // this.$router.push({path:'/dashboard/products/list'})
          // self.insert_factor_products(index+1);

          // }
        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    delete_item_dialog(item) {
      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], this.confirm_delete_name);
      this.status_product_form = item.product_id;

    },
    delete_item() {
      if (this.status_form == 0) {
        this.product_items.forEach((val, index) => {
          if (val.product_id == this.status_product_form) {

            this.product_items.splice(index, 1);
          }
        });
        // this.product_items.splice(this.status_product_form, 1);
        var row_index = 0;
        this.product_items.forEach((val) => {
          val.row_id = row_index;
          row_index += 1;

        });
        this.product_name = "";
        this.product_unit = "";
        this.product_count = "";
        this.product_summary = '';
        this.product_price = 0;
        this.selected_product = null;

        this.status_product_form = -1;
      } else {
        // console.log(this.product_items[this.status_product_form])
        this.delete_factor_products();

      }

    },
    get_document_master() {
      var self = this;
      console.log("route id " + this.$route.params.edit_doc_id);

      const formData = new FormData();

      var url = "GetRecById";

      formData.append("id", this.$route.params.edit_doc_id);

      axios.post(url, formData, {}).then(function (response) {
        console.log("cats is " + response.data);

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
//     self.items_buy = content_data.data.map((item, row_id) => {
// // if(item.isCustomer){
//     return {...item, row_id}
          self.selectedType = content_data.data.docType;
          self.document_person_name = content_data.data.partyName;
          self.document_person = content_data.data.partyId;
          self.total_factor_off_type = content_data.data.factorDiscountType;
          self.total_factor_off = content_data.data.factorDiscount;
          if (self.total_factor_off == '0') {
            self.total_factor_off = '';
          }

          self.async_person_search = false;
          self.async_person_options = [{
            personCode: '',
            surName: '',
            mobileNo: '',
            userId: self.document_person,
            userName: self.document_person_name
          }]
          setTimeout(() => {
            // this.result.push(event.type);
            self.async_person_search = true;
          }, 1500);


          self.date = content_data.data.docDate.replace("-", "/").replace("-", "/");
          self.selected_place = content_data.data.placeId;
          self.document_summary = content_data.data.docDesc;
          if (self.document_summary == null || self.document_summary == 'null') {
            self.document_summary = "";
          }
          //async visitor
          self.async_visitor_search = false
          self.document_visitor = content_data.data.salesManId;
          self.async_visitor_options = [{
            userId:content_data.data.salesManId,
            personCode:content_data.data.salesManTitle,
            userName:'',
            middelName:'',
            surName:'',
            mobileNo:'',
          }]
          setTimeout(function () {
            self.async_visitor_options = true;

          }, 300)
//end async visitor

          self.document_driver = content_data.data.toziKonande;
          self.doc_status = content_data.data.statusId;
          self.tablo = content_data.data.tablo;
          self.address = content_data.data.addressText;
          self.vMobile = content_data.data.vMobile;
          self.partyMobile = content_data.data.partyMobile;
          self.tozikonandeMobile = content_data.data.tozikonandeMobile;
          if (content_data.data.isReorder != null && content_data.data.isReorder != 0) {
            self.document_person = null;
            self.status_form = 0;
          }
          // self.reorder = content_data.data.isReorder;

          for (var i = 0; i < content_data.data.deliveryCostItems.length; i++) {
            if (content_data.data.deliveryCostItems[i].deliveryCostId == 1) {
              self.delivery_cost_amount = content_data.data.deliveryCostItems[i].deliveryCostPrice;
            } else {
              self.selected_sec_cost = content_data.data.deliveryCostItems[i].deliveryCostId
              self.sec_cost_amount = content_data.data.deliveryCostItems[i].deliveryCostPrice;
            }

          }

          self.selected_pay_type = parseInt(content_data.data.payType);

          self.selectedType = content_data.data.docType;
          self.get_document_details();


        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_document_details() {
      var self = this;


      const formData = new FormData();

      var url = "GetDocItemsByDocId";

      formData.append("id", this.$route.params.edit_doc_id);

      axios.post(url, formData, {}).then(function (response) {
        console.log("cats is " + response.data);

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {


          content_data.data.forEach((val) => {
            val.takhfif = val.discount
            val.price = val.price * val.value
            self.add_edit_factor_product_to_document(val);
          });
          var percent_total_price = 0;
          if (self.total_factor_off_type == 2) {
            self.product_items.forEach(function (val) {
              if (val.non_off == false) {
                percent_total_price += self.calculate_total_price(val);
              }
            });
            self.total_factor_off = (self.total_factor_off * 100) / (percent_total_price)

          }
        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }

      })
          .catch(function (error) {
            console.log(error);
          });

    },
    add_edit_factor_product_to_document(item) {
      // ,,"productUnitId":1,"productUnitName":"کارتن 12 تایی","value":12,"qty":1,"price":"11960","docDesc":""
      var product_new_item = [];

      // this.unit_items.forEach((val) => {
      //   if (val.id == item.productUnitId) {
      //   }
      //   // val.row_id = row_index;
      //   // row_index += 1;
      //
      // });
      product_new_item.unit_value = item.value;

      product_new_item.detail_id = item.detailId;
      product_new_item.name = item.productCode + " " + item.productName;
      product_new_item.unit = item.productUnitId;
      if (item.qty < 0) {
        item.qty = item.qty * -1;
      }
      product_new_item.count = item.qty / item.value;
      product_new_item.price = item.price;
      product_new_item.summary = item.docDesc;
      product_new_item.product_id = item.productId;
      product_new_item.non_off = item.nonOff;
      product_new_item.product_off = parseFloat(item.takhfif);
      product_new_item.product_tax = parseFloat(item.tax);
      product_new_item.weight = item.docWeight;


      product_new_item.product_off = (product_new_item.product_off * 100) / (product_new_item.price * product_new_item.count * item.value)
      product_new_item.product_tax = (product_new_item.product_tax * 100) / ((product_new_item.price * product_new_item.count * item.value) - parseFloat(item.takhfif))

      product_new_item.totalPrice = this.calculate_total_price(product_new_item);
      product_new_item.offPrice = this.calculate_off_price(product_new_item);
      product_new_item.taxPrice = this.calculate_tax_price(product_new_item);
      product_new_item.totalPayPrice = this.calculate_total_pay_price(product_new_item);

      this.product_items.push(product_new_item);
      var row_index = 0;
      this.product_items.forEach((val) => {
        val.row_id = row_index;
        row_index += 1;
      });

    },
    delete_factor_products() {

      let self = this;
      const formData = new FormData();
      let url;

      url = "DeleteFactorDetail";
      formData.append('Id', this.product_items.filter(x => x.product_id == this.status_product_form)[0].detail_id)

      // formData.append('model', JSON.stringify(final_sending));

      axios.post(url, formData, {}).then((res) => {


        self.$root.modal_component.show_api_response_modals(res);
        if (res.data.statusCode == 0) {
          self.product_items.forEach((val, index) => {
            if (val.product_id == this.status_product_form) {

              self.product_items.splice(index, 1);
            }
          });
          // this.product_items.splice(this.status_product_form, 1);
          var row_index = 0;
          self.product_items.forEach((val) => {
            val.row_id = row_index;
            row_index += 1;

          });
          self.product_name = "";
          self.product_unit = "";
          self.product_count = "";
          self.product_summary = '';
          self.product_price = 0;
          self.selected_product = null;

          self.status_product_form = -1;
        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },

  }
}

</script>
<style>
.bg-secondary-input input {
  background: #ced2d8 !important;
  color: white;
}
</style>
